import React, { createContext, useContext } from 'react';
const I18nContext = createContext(null);
const dummyT = (key) => key;
export const LANGUAGES = [{ code: 'en', label: 'English' }];
export function I18nProvider({ children }) {
  return <I18nContext.Provider value={{ lang: 'en', setLang: () => {}, t: dummyT, LANGUAGES }}>{children}</I18nContext.Provider>;
}
export function useI18n() { return useContext(I18nContext) || { t: dummyT, lang: 'en', setLang: () => {}, LANGUAGES }; }
export function useTranslation() { return { t: dummyT, i18n: { language: 'en', changeLanguage: () => {} } }; }
export function renderKey(key) { return key; }
export function tReason(reason) { return reason; }
